<template>
  <v-container class="cmp-accounting-costs-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <!-- <div class="dt-details2">
        <div class="dt-details--header" v-if="invoice">
          <div class="title" :title="invoice && invoice.full_name">
            {{ invoice.full_name }}
          </div>
        </div>

        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div v-if="status_text">
                {{ status_text || "Cost Name" }}
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <CostHeaderDetails
        v-if="invoice"
        :selectedCostsDetails="selectedCostsDetails"
      ></CostHeaderDetails>
      <!-- <div :style="{ right: '65px' }" style="position: absolute; top: 140px">
        <div class="tabs-options--panel" style="display: flex">
          <div class="dt-icon-container">
            <img
              @click.stop="(e) => onInvoicePrintClick()"
              src="static/icons/printer.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
        </div>
      </div> -->
      <!-- <div style="position: absolute; top: 116px; right: 65px">
        <div class="tabs-options--panel" style="display: flex">
          <div class="dt-icon-container">
            <img
              @click.stop="(e) => onInvoicePrintClick()"
              src="static/icons/printer.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
        </div>
      </div> -->
      <glayout
        :tabs="costSidewindowTabs"
        :loading="selectedCostsDetails && selectedCostsDetails.loading"
      >
      <template #tabPanelRight>
         <div class="tabs-options--panel" style="display: flex">
          <div class="dt-icon-container">
                  <img
                    v-if="singlePDFDownloadingID > 0"
                    src="static/icons/loading.gif"
                    alt
                    style="height:10px; width:10px;margin: 6px 10px;"
                  />
                  <img
                    v-else
                    @click.stop="(e) => onInvoicePDFClick()"
                    src="static/icons/pdf.svg"
                    class="dt-icon v5 s2"
                    alt
                    :title="`${$t('pdf')}`"
                  />
                </div>
          <div class="dt-icon-container">
            <img
              @click.stop="(e) => onInvoicePrintClick()"
              src="static/icons/printer.svg"
              class="dt-icon v5 h1 s1"
              alt
            />
          </div>
        </div>
        </template>
        <gtab>
          <grow>
            <gcol>
              <gbox h="160" :title="$t('invoice_contact')">
                <InvoiceContact :selectedCostsDetails="selectedCostsDetails" />
              </gbox>

              <gbox :title="$t('description')">
                <DBoxTextarea
                  :value="
                    selectedCostsDetails && selectedCostsDetails.invoice.subject
                  "
                  @blur="
                    (e) =>
                      onCostChanged({ name: 'subject', value: e.target.value })
                  "
                  :style="{ backgroundColor: 'white' }"
                  :id="'subject'"
                />
              </gbox>

              <gbox
                :h="
                  boxHeight(
                    selectedCostsDetails &&
                      selectedCostsDetails.files &&
                      selectedCostsDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_document')"
              >
                <DBoxFiles
                  :files="selectedCostsDetails && selectedCostsDetails.files"
                  :externalId="
                    selectedCostsDetails &&
                    selectedCostsDetails.invoice.invoice_id
                  "
                  :externalTable="'invoices'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox h="323" :title="$t('mandatory_infos')">
                <CostDetails
                  @changed="onCostChanged"
                  :selectedCostsDetails="selectedCostsDetails"
                />
              </gbox>

              <gbox :title="$t('notes_internal')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="
                    selectedCostsDetails && selectedCostsDetails.invoice.notes
                  "
                  @blur="
                    (e) =>
                      onCostChanged({ name: 'notes', value: e.target.value })
                  "
                  :id="'notes'"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="costLines" :title="$t('costLines')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedCostsDetails &&
                      selectedCostsDetails.invoicelines &&
                      selectedCostsDetails.invoicelines.length
                  )
                "
                :title="$t('costlines')"
              >
                <CostLines
                  @changed="onCostLineItemChanged"
                  :selectedCostsDetails="selectedCostsDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox :h="vatHeight" :title="$t('vat')">
                <CostLinesVat
                  @changed="onCostChanged"
                  :selectedCostsDetails="selectedCostsDetails"
                  @change_tax_deduc="onInvoiceTaxDeduc"
                />
              </gbox>
            </gcol>
            <gcol>
              <!-- <CostLinesSummery :selectedCostsDetails="selectedCostsDetails" /> -->
            </gcol>
          </grow>
        </gtab>
        <gtab id="payments" :title="$t('payments')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedCostsDetails &&
                      selectedCostsDetails.payments &&
                      selectedCostsDetails.payments.length
                  )
                "
                :title="$t('payments')"
              >
                <Payments
                  @changed_invoice="onCostChanged"
                  @changed="onPaymentChange"
                  @currency_changed="onPaymentCurrencyChange"
                  :selectedCostsDetails="selectedCostsDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="assign_projects" :title="$t('Assign Projects')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedCostsDetails &&
                      selectedCostsDetails.cost_splits &&
                      selectedCostsDetails.cost_splits.length
                  )
                "
                :title="$t('contract_cost_split')"
              >
                <CostSplits
                  @add_click="onAddClick"
                  @changed="onCostItemChanged"
                  :selectedCostsDetails="selectedCostsDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="royalty_accounts">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedCostsDetails &&
                      selectedCostsDetails.recoupables &&
                      selectedCostsDetails.recoupables.length
                  )
                "
                :title="$t('recoupables')"
              >
                <Recoupables
                  @changed="onCostItemChanged"
                  :selectedCostsDetails="selectedCostsDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <!-- <ModalContainer :modalKey="'costRecoupables'" :width="'small'">
      <CostRecoupables
        @cancelled="onDialogCancelled"
        @added="onCostRecoupablesAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer> -->
    <ModalContainer :modalKey="'addCostSplit'" :width="'small'">
      <AddCostSplit
        @cancelled="onDialogCancelled"
        @added="onCostSplitAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addInvoiceContact'" :width="'medium'">
      <AddInvoiceContact
        :selectedCostsDetails="selectedCostsDetails"
        @done="onAssignContact"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costSplitRelease'" :width="'medium3'">
      <CostSplitRelease
        @cancelled="onDialogCancelled"
        @added="onCostRecoupablesAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costSplitProduct'" :width="'medium3'">
      <CostSplitProduct
        @cancelled="onDialogCancelled"
        @added="onCostRecoupablesAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costSplitBooking'" :width="'medium3'">
      <CostSplitBooking
        @cancelled="onDialogCancelled"
        @added="onCostRecoupablesAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costSplitTour'" :width="'medium3'">
      <CostSplitTour
        @cancelled="onDialogCancelled"
        @added="onCostRecoupablesAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'taxTypeModal'" :width="'small'">
      <TaxTypeModal
        @cancelled="onDialogCancelled"
        @added="onCostRecoupablesAdded"
        :selectedCostsDetails="selectedCostsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costSplitEditForm'" :width="'small'">
      <CostSplitEditForm @changed="onUpdated" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'costOpenAdvance'"
      :width="'small'"
    >
      <DBoxCostOpenAdvance
        :itemName="'Cost'"
        :config="config"
        @cancelled="onCancel"
        @advance_made="onCancel"
      />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'costRecoupables'"
      :width="'928'"
    >
      <DBoxCostRecoupables @cancelled="onCancel" />
    </ModalContainer>
  </v-container>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import { createTV } from "../../../../models/text-value.model";
import { costsGetters } from "../../store/costs/getters";
import { costListLDTRoutes } from "../../router/routes";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { checkTabListPermission } from "../../../../router/guard";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import DBoxCostOpenAdvance from "../../../../dt-plugins/dbox-costs/dbox-costs-open-advance.vue";
import DBoxCostRecoupables from "../../../../dt-plugins/dbox-costs/dbox-costs-recoupables";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
  closeModal2Route,
} from "../../../../dt-plugins/modal/modal.mixin";
import CostDetails from "./cost-details.vue";
import CostLines from "./costlines-list";
import CostLinesSummery from "./costlines-summery";
import CostLinesVat from "./cost_lines_vat.vue";
import Payments from "./payments-list";
import CostSplits from "./cost-split-list";
import InvoiceContact from "./invoice-contact.vue";
import Recoupables from "./royalty-accounts-recoupables";
import { CostsService } from "../../services/costs.service";
import ModalContainer from "@dtplugins/modal/modal-container";
import AddCostSplit from "./cost-split-add";
import CostSplitEditForm from "./cost-split-edit-form.vue";
import RecoupablesForm from "./recoupables-form.vue";
import AddInvoiceContact from "./add-invoice-contact";
import CostSplitRelease from "./cost-split-add-release";
import CostSplitProduct from "./cost-split-add-product";
import CostSplitBooking from "./cost-split-add-booking";
import TaxTypeModal from "./set-tax-type-modal.vue";
import { HttpClient } from "../../../../services/http/http-client";
import CostSplitTour from "./cost-split-add-tour";
import { tv } from "../../../../models/text-value.model";
import CostHeaderDetails from "./cost-header-details";
import { createCurrencyTV } from "../../../../models/currency.model";
import { openWindow, createMailHref, downloadPDF } from "../../../../utility";
export const moduleRoute = "accounting";
export const submenuRoute = "costs";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    DBoxFiles,
    ModalContainer,
    InvoiceContact,
    CostDetails,
    CostLines,
    CostLinesSummery,
    CostSplits,
    Recoupables,
    Payments,
    CostLinesVat,
    AddCostSplit,
    AddInvoiceContact,
    CostSplitRelease,
    CostSplitProduct,
    CostSplitBooking,
    CostSplitTour,
    TaxTypeModal,
    CostSplitEditForm,
    DBoxCostRecoupables,
    DBoxCostOpenAdvance,
    CostHeaderDetails,
  },
  data() {
    return {singlePDFDownloadingID:0};
  },
  mixins: [
    createDTGridHost(),

    createModalMixin("addCostSplit"),
    createModalMixin("costSplitRelease"),
    createModalMixin("costSplitProduct"),
    createModalMixin("costSplitBooking"),
    createModalMixin("costSplitTour"),
    createModalMixin("addInvoiceContact"),
    createModalMixin("taxTypeModal"),
    createModalMixin("costSplitEditForm"),
    createModalMixin("costRecoupables"),
    createModalMixin("costOpenAdvance"),
  ],
  computed: {
    ...mapGetterObject(storeNS, costsGetters),
    costSidewindowTabs: function () {
      return checkTabListPermission("accounting", "costs", [
        { route: "overview", value: "Overview" },
        {
          route: "costLines",
          value: "CostLines",
        },
        {
          route: "payments",
          value: "Payments",
        },
        {
          route: "assign_projects",
          value: "Assign Projects",
        },
        {
          route: "royalty_accounts",
          value: "Royalty Accounts",
        },
      ]);
    },

    // TABULATION REFACTORING
    invoice: function () {
      return this.selectedCostsDetails ? this.selectedCostsDetails.invoice : {};
    },
    vatHeight: function () {
      return this.selectedCostsDetails?.invoice?.vat_handling == 1 ||
        this.selectedCostsDetails?.invoice?.vat_handling == 2
        ? 196
        : 132;
    },
    status_text: function () {
      return this.invoice?.invoice_project_name
        ? `${this.invoice.invoice_project_name}/${this.invoice.invoice_date}/${this.invoice.currency_iso}/${this.invoice.external_ref}/${this.invoice.invoice_ref}`
        : null;
    },
    invoice_id: function () {
      return this.$route.params.invoice_id;
    },
    config: function () {
      return {
        externalTable: "release",
      };
    },

    selectedCostsDetails: function () {
      const selectedInvoice = this.costsDetails?.[this.invoice_id] || {};
      console.log("selectedInvoice", selectedInvoice);
      let invoice = selectedInvoice?.invoice || {};
      console.log("invoice", invoice);
      const invoice_project_name = selectedInvoice?.invoice_projects
        ? selectedInvoice?.invoice_projects.find(
            (i) => i.invoice_project_id == invoice.invoice_project_id
          )?.invoice_project_name
        : "";
      invoice.full_name =selectedInvoice.full_name? selectedInvoice.full_name:invoice.full_name;
      invoice.invoice_project_name = invoice_project_name;
      const contact = {
        vat_no: null,
      };
      const currencies = selectedInvoice?.currencies || [];
      const invoiceCurrencyId = invoice.currency_id || "";
      const invoiceCurrency =
        currencies.find((e) => {
          if (invoiceCurrencyId != "") {
            return e.currency_id == invoiceCurrencyId;
          } else {
            return e.currency_iso == selectedInvoice?.client?.default_currency;
          }
        }) || {};
      const status_color = selectedInvoice?.invoice?.status_color || "";
      const currenciesTV = createCurrencyTV(currencies);
      const invoiceBackground =
        {
          "#07f300": "64C896",
          "#fffe00": "E6DC64",
          "#0000ff": "86C0F4",
          "#fd5b2c": "FA8237",
          "#ca0005": "FF6E6E",
          "#666666": "C8C8C8",
          "#000000": "505050",
        }[status_color] || "jordyblue";
      const tax_deductions = selectedInvoice?.tax_deductions || [];
      const tax_deductionsTV = tax_deductions.map(
        tv("tax_group_name", "tax_group_id")
      );
      const selectedTaxDeduction = (
        tax_deductionsTV.find(
          (c) => c.value == invoice.tax_type_id_deduction
        ) || {}
      ).text;
      const vatRatesTV = [
        { value: 1, text: invoice?.vat_rate1 ?? "0.00" },
        { value: 2, text: invoice?.vat_rate2 ?? "0.00" },
        { value: 3, text: invoice?.vat_rate3 ?? "0.00" },
      ];
      const costLinesVatRatesTV = [
        { value: invoice?.vat_rate1 ?? 0, text: invoice?.vat_rate1 ?? "0.00" },
        { value: invoice?.vat_rate2 ?? 0, text: invoice?.vat_rate2 ?? "0.00" },
        { value: invoice?.vat_rate3 ?? 0, text: invoice?.vat_rate3 ?? "0.00" },
      ];
      return {
        ...selectedInvoice,
        invoice,
        contact,
        invoiceBackground,
        tax_deductionsTV,
        selectedTaxDeduction,
        invoiceCurrency,
        vatRatesTV,
        costLinesVatRatesTV,
        currenciesTV
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onCostChanged: function (payload) {
      this[ActionTypes.CostsDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedCostsDetails,
      });
    },
    onPaymentCurrencyChange: function (payload) {
      this.updatePayment(payload);
    },
    onPaymentChange: function (payload) {
      this.updatePayment(payload);
    },
    updatePayment: function (payload) {
      this[ActionTypes.AccountingCostPayments.UPDATE.SINGLE]({
        ...payload,
        invoice: this.invoice,
      });
    },
    onInvoiceTaxDeduc: function ({ name, value }) {
      this[ActionTypes.CHANGE_COST_TAX_DEDUC]({
        item: this.invoice,
        [name]: value,
      });
    },
    updateData: function (item) {
      const invoicelines = this.selectedCostsDetails.invoicelines.map((b) => {
        if (b.invoiceline_id === item.invoiceline_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.AccountingCostLines.SET.ALL]({
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        invoicelines: invoicelines || [],
      });
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    updateData: function (item) {},
    onCostLineItemChanged: async function (payload) {
      const { item } = payload;
      const res = await CostsService.modify({
        ...payload,
      });

      const invoicelines = this.selectedCostsDetails.invoicelines.map((b) => {
        if (b.invoiceline_id === item.invoiceline_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.AccountingCostLines.SET.ALL]({
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        invoicelines: invoicelines || [],
      });
    },
    onCostItemChanged: async function (payload) {
      const res = await CostsService.modify({
        ...payload,
      });

      CostsService.findCostOverViewTabData(this.invoice_id).then((res1) => {
        this[ActionTypes.AccountingCostOverview.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          overview: res1.data || [],
        });
      });
    },
    onInvoicePrintClick: async function () {
      const { invoice_id } = this.selectedCostsDetails.invoice;
      if (invoice_id) {
        openWindow(
          `${HttpClient.getBaseUrl()}/accounting.pl?section=costs&action=print_costs&invoice_id=${invoice_id}`,
          "Print Invoice",
          { wr: 0.7, hr: 0.7 }
        );
      }
    },
    onCostSplitAdded: function () {},
    onAssignContact: function (invoice) {
      this[ActionTypes.AccountingCostsInvoice.SET.ALL]({
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        invoice: invoice || [],
      });
      this.onDialogCancelled();
    },
    onUpdated: function (payload) {},
    onCostRecoupablesAdded: function () {},
    onCancel: function () {
      closeModalRoute(this);
      closeModal2Route(this);
      CostsService.invoiceTotalCostSplit(
        this.selectedCostsDetails.invoice.invoice_id
      ).then((res) => {
        const amount = res.data.amount;
        this[ActionTypes.InvoiceTotalCostSplit.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          amount: amount || 0,
        });
      });
      CostsService.findCostAssignProjects(
        this.selectedCostsDetails.invoice.invoice_id
      ).then((res) => {
        const cost_splits = res.data.cost_splits;
        this[ActionTypes.AccountingCostSplits.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          cost_splits: cost_splits || [],
        });
      });
    },
    onInvoicePDFClick: async function () {
      if(this.singlePDFDownloadingID > 0){
        return;
      }

      const { invoice_id, invoice_ref } = this.selectedCostsDetails.invoice;
      this.singlePDFDownloadingID = invoice_id;

      const filename = `${invoice_ref}.pdf`;
      const printURL = `${HttpClient.getBaseUrl()}/accounting.pl?section=invoices&action=print_invoice&invoice_id=${invoice_id}`;

      await downloadPDF(printURL, this.$store.getters.account, filename);
      this.singlePDFDownloadingID = 0;
    },
    onSelectedCost: function (invoiceId) {
      this.$router.push({
        name: costListLDTRoutes.names.tab,
        params: {
          invoice_id: invoiceId,
          tab: "overview",
        },
      });
    },

    // MARK: Methods

    onAdded: function (payload) {
      this.onDialogCancelled();
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onEditClick: function (e) {
      // openModalRoute(this, "edit_payment_form", {
      //   mode: "add",
      // });
      // this.selectedPayment = {
      //   ...e,
      // };
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 200px);
  }
  .contract-document {
    margin: 0px;
  }
}
</style>
